import { Page } from 'components/layout';
import { Flex, Box, Message, Loading } from 'components/ui';
import { useQuery, useQueryClient } from 'react-query'
import { Col, Row } from 'react-grid-system';
import useFutura from 'hooks/useFutura';
import ConnectedWalletGuard from 'components/ConnectedWalletGuard';
import futuraPreview from 'img/futura-preview-redeem.png';
import FuturaRedeem from 'components/FuturaRedeem';
import { futuraChainId } from 'utils/config';
import { FuturaDropStage, REQUEST_STATUS } from '../../constants';
import { useContract, Contracts } from 'hooks/useContract';
import { mixpassToken } from 'components/Mixpass/mixpassConfig';
import { useWallet } from 'components/WalletContext';
import { Polling } from 'components/common';

const Redemption = () => {
  const { dropStage, mintMixes } = useFutura();
  const mixpassTokenContract = useContract(
    mixpassToken.address,
    Contracts.CVWearables,
    futuraChainId,
  );
  const { address } = useWallet();
  const queryClient = useQueryClient();

  const { data: mixpassBalance, status } = useQuery(
    ['mixpassBalance', address],
    async () => mixpassTokenContract!.balanceOf(address, mixpassToken.tokenId),
    {
      enabled:
        Boolean(mixpassTokenContract) &&
        Boolean(address),
      refetchInterval: Polling.average,
    }
  );

  return (
    <Box>
      {
        (dropStage === null
        || mixpassTokenContract === null
        || status === REQUEST_STATUS.loading)
        && (
          <Loading />
        )
      }
      {
        dropStage === FuturaDropStage.SETUP && (
          <Message color="black">
            Redemption not enabled yet.
          </Message>
        )
      }
      {
        dropStage === FuturaDropStage.MIXES_AVAILABLE &&
        mixpassTokenContract &&
          address && (
          <FuturaRedeem
            mintMixes={mintMixes}
            mixPassBalance={mixpassBalance?.toNumber()}
            mixpassContract={mixpassTokenContract}
            userAddress={address}
            onSuccess={() => {
              queryClient.invalidateQueries(['mixpassBalance', address])
            }}
          />
        )
      }
      {
        dropStage === FuturaDropStage.SALE_COMPLETE && (
          <Message>
            Futura mixes Sold Out.
          </Message>
        )
      }
      {
        dropStage === FuturaDropStage.REMIXING_ENABLED && (
          <Message>
            Redemption period has ended.
          </Message>
        )
      }
    </Box>
  );
}

const FuturaRedemptionPage = () => {
  return (
    <Page
      title="Futura Mixpass Redemption"
      padding="0"
      background="#333"
      fixedFooter={false}
    >
      <Box>
        <Row>
          <Col sm={12} md={6}>
            <Box py={2} px={['16px', '24px']}>
              <Box my={3} fontSize={20} fontWeight="bold">
                Futura Mixpass Redemption
              </Box>
              <ConnectedWalletGuard networkId={futuraChainId}>
                <Redemption />
              </ConnectedWalletGuard>
            </Box>
          </Col>
          <Col sm={12} md={6}>
            <Flex
              background="black"
              width="100%"
              height="690px"
              justifyCenter
              alignCenter
            >
              <img src={futuraPreview} alt="Futura Preview" width="480px" />
            </Flex>
          </Col>
        </Row>
      </Box>
    </Page>    
  )
}

export default FuturaRedemptionPage;
